import { Form, Button, Row, Col, Card } from 'react-bootstrap'
import AppLoader from 'components/general/AppLoader';
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"
import { useState } from 'react'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html';

export default function AddNewModal({ getEvents }) {
  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [eventType, setEventType] = useState('')
  const [name, setName] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState(EditorState.createEmpty())
  const [subdescription, setSubdescription] = useState(EditorState.createEmpty())
  const [green, setGreen] = useState('')
  const [amber, setAmber] = useState('')
  const [red, setRed] = useState('')
  const [total, setTotal] = useState('')

  const [saveLoading, setSaveLoading] = useState(false)
  const [showCard, setShowCard] = useState(false)
  const handleCloseCard = () => setShowCard(false)
  const handleShowCard = () => setShowCard(true)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaveLoading(true)

    const descriptionHtml = draftToHtml(convertToRaw(description.getCurrentContent()))
    const subDescriptionHTML = draftToHtml(convertToRaw(subdescription.getCurrentContent()))

    try {
      const response = await fetch(`${url}/agendaEvent`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
        body: JSON.stringify({
          eventType,
          name,
          title,
          description: descriptionHtml,
          subdescription: subDescriptionHTML,
          green,
          amber,
          red,
          total
        })
      })

      if (response.status === 201) {
        await response.json()
        getEvents() // Refresh the event list
        handleCloseCard()
      } else {
        console.log(response)
        toast.error(`Failed to add Event: ${response.statusText}. Check the mandatory fields`, { position: 'bottom-left' })
      }
    } catch (error) {
      console.error(error)
      toast.error('Failed to add Event', { position: 'bottom-left' })
    } finally {
      setSaveLoading(false)
    }
  }

  return (
    <>
      {!showCard && (
        <Button
          variant="success"
          onClick={handleShowCard}
          className="mb-3 w-100 events-admin-add-btn"
        >
          <i className="bi bi-plus"></i> Add New Event
        </Button>
      )}
      {showCard && (
        <Card className="mb-3 mt-3 events-admin-form-card" id="addEvent" style={{ display: showCard ? 'block' : 'none' }}>
          <Form>
            <Card.Body className='events-admin-form-body'>
              <Form.Group className='mb-3'>
                {/* <Form.Label>Event Type</Form.Label> */}
                <Form.Select
                  aria-label='Event Type*'
                  className='mb-3'
                  name='eventType'
                  // style={{ backgroundColor: '#146c43', color: '#ffffff' }}
                  value={eventType}
                  onChange={e => setEventType(e.target.value)}
                >
                  <option value=''>Select Event Type*</option>
                  <option value='regular'>Event type: Regular</option>
                  <option value='pathway'>Event type: Pathway</option>
                  <option value='poll'>Event type: Poll</option>
                  <option value='pollresult'>Event type: Contest Results</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Control
                  placeholder='Event Name*'
                  className='formInput'
                  aria-label='Event Name*'
                  name='role'
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Control
                  placeholder='Event Title'
                  className='formInput'
                  aria-label='Event Tame'
                  name='Title'
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Editor
                  editorState={description}
                  wrapperClassName="demo-wrapper"
                  toolbarClassName="toolbar-class"
                  editorClassName="editor-class"
                  onEditorStateChange={setDescription}
                  placeholder="Enter role description..."
                  toolbar={{
                    options: ['inline', 'blockType', 'list', 'textAlign', 'link'],
                    inline: {
                      options: ['bold', 'italic', 'underline']
                    },
                    blockType: {
                      inDropdown: false,
                      options: ['Normal', 'H4', 'H5', 'H6']
                    },
                    fontSize: {
                      visible: false,
                      options: [8, 9, 10, 11, 12, 14, 18]
                    },
                    list: {
                      inDropdown: false,
                      options: ['unordered', 'ordered']
                    },
                    textAlign: {
                      inDropdown: false
                    },
                    link: {
                      inDropdown: false
                    },
                    embedded: {
                      inDropdown: false
                    },
                  }}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Editor
                  editorState={subdescription}
                  wrapperClassName="demo-wrapper"
                  toolbarClassName="toolbar-class"
                  editorClassName="editor-class"
                  onEditorStateChange={setSubdescription}
                  placeholder="Enter role extra description..."
                  toolbar={{
                    options: ['inline', 'blockType', 'list', 'textAlign', 'link'],
                    inline: {
                      options: ['bold', 'italic', 'underline']
                    },
                    blockType: {
                      inDropdown: false,
                      options: ['Normal', 'H4', 'H5', 'H6']
                    },
                    fontSize: {
                      visible: false,
                      options: [8, 9, 10, 11, 12, 14, 18]
                    },
                    list: {
                      inDropdown: false,
                      options: ['unordered', 'ordered']
                    },
                    textAlign: {
                      inDropdown: false
                    },
                    link: {
                      inDropdown: false
                    },
                    embedded: {
                      inDropdown: false
                    },
                  }}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label className='events-admin-form-label'>Time Limits</Form.Label>
                <Row>
                  <Col>
                    <Form.Select
                      aria-label='Green'
                      className='mb-3'
                      name='Green'
                      style={{ backgroundColor: '#146c43', color: '#ffffff' }}
                      value={green}
                      onChange={e => setGreen(e.target.value)}
                    >
                      <option value=''>Green</option>
                      <option value='0:00'>0:00</option>
                      <option value='0:30'>0:30</option>
                      <option value='1:00'>1:00</option>
                      <option value='1:30'>1:30</option>
                      <option value='2:00'>2:00</option>
                      <option value='2:30'>2:30</option>
                      <option value='3:00'>3:00</option>
                      <option value='3:30'>3:30</option>
                      <option value='4:00'>4:00</option>
                      <option value='4:30'>4:30</option>
                      <option value='5:00'>5:00</option>
                      <option value='5:30'>5:30</option>
                      <option value='6:00'>6:00</option>
                      <option value='6:30'>6:30</option>
                      <option value='7:00'>7:00</option>
                      <option value='7:30'>7:30</option>
                      <option value='8:00'>8:00</option>
                      <option value='8:30'>8:30</option>
                      <option value='9:00'>9:00</option>
                      <option value='9:30'>9:30</option>
                      <option value='10:00'>10:00</option>
                      <option value='10:30'>10:30</option>
                      <option value='11:00'>11:00</option>
                      <option value='11:30'>11:30</option>
                      <option value='12:00'>12:00</option>
                      <option value='12:30'>12:30</option>
                      <option value='13:00'>13:00</option>
                      <option value='13:30'>13:30</option>
                      <option value='14:00'>14:00</option>
                      <option value='14:30'>14:30</option>
                      <option value='15:00'>15:00</option>
                      <option value='15:30'>15:30</option>
                      <option value='16:00'>16:00</option>
                      <option value='16:30'>16:30</option>
                      <option value='17:00'>17:00</option>
                      <option value='17:30'>17:30</option>
                      <option value='18:00'>18:00</option>
                      <option value='18:30'>18:30</option>
                      <option value='19:00'>19:00</option>
                      <option value='19:30'>19:30</option>
                      <option value='20:00'>20:00</option>
                      <option value='20:30'>20:30</option>
                      <option value='21:00'>21:00</option>
                      <option value='21:30'>21:30</option>
                      <option value='22:00'>22:00</option>
                      <option value='22:30'>22:30</option>
                      <option value='23:00'>23:00</option>
                      <option value='23:30'>23:30</option>
                      <option value='24:00'>24:00</option>
                      <option value='24:30'>24:30</option>
                      <option value='25:00'>25:00</option>
                      <option value='25:30'>25:30</option>
                      <option value='26:00'>26:00</option>
                      <option value='26:30'>26:30</option>
                      <option value='27:00'>27:00</option>
                      <option value='27:30'>27:30</option>
                      <option value='28:00'>28:00</option>
                      <option value='28:30'>28:30</option>
                      <option value='29:00'>29:00</option>
                      <option value='29:30'>29:30</option>
                      <option value='30:00'>30:00</option>
                      <option value='30:30'>30:30</option>
                      <option value='31:00'>31:00</option>
                      <option value='31:30'>31:30</option>
                      <option value='32:00'>32:00</option>
                      <option value='32:30'>32:30</option>
                      <option value='33:00'>33:00</option>
                      <option value='33:30'>33:30</option>
                      <option value='34:00'>34:00</option>
                      <option value='34:30'>34:30</option>
                      <option value='35:00'>35:00</option>
                      <option value='35:30'>35:30</option>
                      <option value='36:00'>36:00</option>
                      <option value='36:30'>36:30</option>
                      <option value='37:00'>37:00</option>
                      <option value='37:30'>37:30</option>
                      <option value='38:00'>38:00</option>
                      <option value='38:30'>38:30</option>
                      <option value='39:00'>39:00</option>
                      <option value='39:30'>39:30</option>
                      <option value='40:00'>40:00</option>
                      <option value='40:30'>40:30</option>
                      <option value='41:00'>41:00</option>
                      <option value='41:30'>41:30</option>
                      <option value='42:00'>42:00</option>
                      <option value='42:30'>42:30</option>
                      <option value='43:00'>43:00</option>
                      <option value='43:30'>43:30</option>
                      <option value='44:00'>44:00</option>
                      <option value='44:30'>44:30</option>
                      <option value='45:00'>45:00</option>
                      <option value='45:30'>45:30</option>
                      <option value='46:00'>46:00</option>
                      <option value='46:30'>46:30</option>
                      <option value='47:00'>47:00</option>
                      <option value='47:30'>47:30</option>
                      <option value='48:00'>48:00</option>
                      <option value='48:30'>48:30</option>
                      <option value='49:00'>49:00</option>
                      <option value='49:30'>49:30</option>
                      <option value='50:00'>50:00</option>
                      <option value='50:30'>50:30</option>
                      <option value='51:00'>51:00</option>
                      <option value='51:30'>51:30</option>
                      <option value='52:00'>52:00</option>
                      <option value='52:30'>52:30</option>
                      <option value='53:00'>53:00</option>
                      <option value='53:30'>53:30</option>
                      <option value='54:00'>54:00</option>
                      <option value='54:30'>54:30</option>
                      <option value='55:00'>55:00</option>
                      <option value='55:30'>55:30</option>
                      <option value='56:00'>56:00</option>
                      <option value='56:30'>56:30</option>
                      <option value='57:00'>57:00</option>
                      <option value='57:30'>57:30</option>
                      <option value='58:00'>58:00</option>
                      <option value='58:30'>58:30</option>
                      <option value='59:00'>59:00</option>
                      <option value='59:30'>59:30</option>
                      <option value='60:00'>60:00</option>
                      <option value='60:30'>60:30</option>
                      <option value='61:00'>61:00</option>
                      <option value='61:30'>61:30</option>
                      <option value='62:00'>62:00</option>
                      <option value='62:30'>62:30</option>
                      <option value='63:00'>63:00</option>
                      <option value='63:30'>63:30</option>
                      <option value='64:00'>64:00</option>
                      <option value='64:30'>64:30</option>
                      <option value='65:00'>65:00</option>
                      <option value='65:30'>65:30</option>
                      <option value='66:00'>66:00</option>
                      <option value='66:30'>66:30</option>
                      <option value='67:00'>67:00</option>
                      <option value='67:30'>67:30</option>
                      <option value='68:00'>68:00</option>
                      <option value='68:30'>68:30</option>
                      <option value='69:00'>69:00</option>
                      <option value='69:30'>69:30</option>
                      <option value='70:00'>70:00</option>
                      <option value='70:30'>70:30</option>
                      <option value='71:00'>71:00</option>
                      <option value='71:30'>71:30</option>
                      <option value='72:00'>72:00</option>
                      <option value='72:30'>72:30</option>
                      <option value='73:00'>73:00</option>
                      <option value='73:30'>73:30</option>
                      <option value='74:00'>74:00</option>
                      <option value='74:30'>74:30</option>
                      <option value='75:00'>75:00</option>
                      <option value='75:30'>75:30</option>
                      <option value='76:00'>76:00</option>
                      <option value='76:30'>76:30</option>
                      <option value='77:00'>77:00</option>
                      <option value='77:30'>77:30</option>
                      <option value='78:00'>78:00</option>
                      <option value='78:30'>78:30</option>
                      <option value='79:00'>79:00</option>
                      <option value='79:30'>79:30</option>
                      <option value='80:00'>80:00</option>
                      <option value='80:30'>80:30</option>
                      <option value='81:00'>81:00</option>
                      <option value='81:30'>81:30</option>
                      <option value='82:00'>82:00</option>
                      <option value='82:30'>82:30</option>
                      <option value='83:00'>83:00</option>
                      <option value='83:30'>83:30</option>
                      <option value='84:00'>84:00</option>
                      <option value='84:30'>84:30</option>
                      <option value='85:00'>85:00</option>
                      <option value='85:30'>85:30</option>
                      <option value='86:00'>86:00</option>
                      <option value='86:30'>86:30</option>
                      <option value='87:00'>87:00</option>
                      <option value='87:30'>87:30</option>
                      <option value='88:00'>88:00</option>
                      <option value='88:30'>88:30</option>
                      <option value='89:00'>89:00</option>
                      <option value='89:30'>89:30</option>
                      <option value='90:00'>90:00</option>
                      <option value='90:30'>90:30</option>
                      <option value='91:00'>91:00</option>
                      <option value='91:30'>91:30</option>
                      <option value='92:00'>92:00</option>
                      <option value='92:30'>92:30</option>
                      <option value='93:00'>93:00</option>
                      <option value='93:30'>93:30</option>
                      <option value='94:00'>94:00</option>
                      <option value='94:30'>94:30</option>
                      <option value='95:00'>95:00</option>
                      <option value='95:30'>95:30</option>
                      <option value='96:00'>96:00</option>
                      <option value='96:30'>96:30</option>
                      <option value='97:00'>97:00</option>
                      <option value='97:30'>97:30</option>
                      <option value='98:00'>98:00</option>
                      <option value='98:30'>98:30</option>
                      <option value='99:00'>99:00</option>
                      <option value='99:30'>99:30</option>
                      <option value='100:00'>100:00</option>
                      <option value='100:30'>100:30</option>
                      <option value='101:00'>101:00</option>
                      <option value='101:30'>101:30</option>
                      <option value='102:00'>102:00</option>
                      <option value='102:30'>102:30</option>
                      <option value='103:00'>103:00</option>
                      <option value='103:30'>103:30</option>
                      <option value='104:00'>104:00</option>
                      <option value='104:30'>104:30</option>
                      <option value='105:00'>105:00</option>
                      <option value='105:30'>105:30</option>
                      <option value='106:00'>106:00</option>
                      <option value='106:30'>106:30</option>
                      <option value='107:00'>107:00</option>
                      <option value='107:30'>107:30</option>
                      <option value='108:00'>108:00</option>
                      <option value='108:30'>108:30</option>
                      <option value='109:00'>109:00</option>
                      <option value='109:30'>109:30</option>
                      <option value='110:00'>110:00</option>
                      <option value='110:30'>110:30</option>
                      <option value='111:00'>111:00</option>
                      <option value='111:30'>111:30</option>
                      <option value='112:00'>112:00</option>
                      <option value='112:30'>112:30</option>
                      <option value='113:00'>113:00</option>
                      <option value='113:30'>113:30</option>
                      <option value='114:00'>114:00</option>
                      <option value='114:30'>114:30</option>
                      <option value='115:00'>115:00</option>
                      <option value='115:30'>115:30</option>
                      <option value='116:00'>116:00</option>
                      <option value='116:30'>116:30</option>
                      <option value='117:00'>117:00</option>
                      <option value='117:30'>117:30</option>
                      <option value='118:00'>118:00</option>
                      <option value='118:30'>118:30</option>
                      <option value='119:00'>119:00</option>
                      <option value='119:30'>119:30</option>
                      <option value='120:00'>120:00</option>
                      <option value='120:30'>120:30</option>
                      <option value='121:00'>121:00</option>
                      <option value='121:30'>121:30</option>
                      <option value='122:00'>122:00</option>
                      <option value='122:30'>122:30</option>
                      <option value='123:00'>123:00</option>
                      <option value='123:30'>123:30</option>
                      <option value='124:00'>124:00</option>
                      <option value='124:30'>124:30</option>
                      <option value='125:00'>125:00</option>
                      <option value='125:30'>125:30</option>
                      <option value='126:00'>126:00</option>
                      <option value='126:30'>126:30</option>
                      <option value='127:00'>127:00</option>
                      <option value='127:30'>127:30</option>
                      <option value='128:00'>128:00</option>
                      <option value='128:30'>128:30</option>
                      <option value='129:00'>129:00</option>
                      <option value='129:30'>129:30</option>
                      <option value='130:00'>130:00</option>
                      <option value='130:30'>130:30</option>
                      <option value='131:00'>131:00</option>
                      <option value='131:30'>131:30</option>
                      <option value='132:00'>132:00</option>
                      <option value='132:30'>132:30</option>
                      <option value='133:00'>133:00</option>
                      <option value='133:30'>133:30</option>
                      <option value='134:00'>134:00</option>
                      <option value='134:30'>134:30</option>
                      <option value='135:00'>135:00</option>
                      <option value='135:30'>135:30</option>
                      <option value='136:00'>136:00</option>
                      <option value='136:30'>136:30</option>
                      <option value='137:00'>137:00</option>
                      <option value='137:30'>137:30</option>
                      <option value='138:00'>138:00</option>
                      <option value='138:30'>138:30</option>
                      <option value='139:00'>139:00</option>
                      <option value='139:30'>139:30</option>
                      <option value='140:00'>140:00</option>
                      <option value='140:30'>140:30</option>
                      <option value='141:00'>141:00</option>
                      <option value='141:30'>141:30</option>
                      <option value='142:00'>142:00</option>
                      <option value='142:30'>142:30</option>
                      <option value='143:00'>143:00</option>
                      <option value='143:30'>143:30</option>
                      <option value='144:00'>144:00</option>
                      <option value='144:30'>144:30</option>
                      <option value='145:00'>145:00</option>
                      <option value='145:30'>145:30</option>
                      <option value='146:00'>146:00</option>
                      <option value='146:30'>146:30</option>
                      <option value='147:00'>147:00</option>
                      <option value='147:30'>147:30</option>
                      <option value='148:00'>148:00</option>
                      <option value='148:30'>148:30</option>
                      <option value='149:00'>149:00</option>
                      <option value='149:30'>149:30</option>
                      <option value='150:00'>150:00</option>

                    </Form.Select>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label='Amber'
                      className='mb-3'
                      name='Amber'
                      style={{ backgroundColor: '#ffc107', color: '#000000' }}
                      value={amber}
                      onChange={e => setAmber(e.target.value)}
                    >
                      <option value=''>Amber</option>
                      <option value='0:00'>0:00</option>
                      <option value='0:30'>0:30</option>
                      <option value='1:00'>1:00</option>
                      <option value='1:30'>1:30</option>
                      <option value='2:00'>2:00</option>
                      <option value='2:30'>2:30</option>
                      <option value='3:00'>3:00</option>
                      <option value='3:30'>3:30</option>
                      <option value='4:00'>4:00</option>
                      <option value='4:30'>4:30</option>
                      <option value='5:00'>5:00</option>
                      <option value='5:30'>5:30</option>
                      <option value='6:00'>6:00</option>
                      <option value='6:30'>6:30</option>
                      <option value='7:00'>7:00</option>
                      <option value='7:30'>7:30</option>
                      <option value='8:00'>8:00</option>
                      <option value='8:30'>8:30</option>
                      <option value='9:00'>9:00</option>
                      <option value='9:30'>9:30</option>
                      <option value='10:00'>10:00</option>
                      <option value='10:30'>10:30</option>
                      <option value='11:00'>11:00</option>
                      <option value='11:30'>11:30</option>
                      <option value='12:00'>12:00</option>
                      <option value='12:30'>12:30</option>
                      <option value='13:00'>13:00</option>
                      <option value='13:30'>13:30</option>
                      <option value='14:00'>14:00</option>
                      <option value='14:30'>14:30</option>
                      <option value='15:00'>15:00</option>
                      <option value='15:30'>15:30</option>
                      <option value='16:00'>16:00</option>
                      <option value='16:30'>16:30</option>
                      <option value='17:00'>17:00</option>
                      <option value='17:30'>17:30</option>
                      <option value='18:00'>18:00</option>
                      <option value='18:30'>18:30</option>
                      <option value='19:00'>19:00</option>
                      <option value='19:30'>19:30</option>
                      <option value='20:00'>20:00</option>
                      <option value='20:30'>20:30</option>
                      <option value='21:00'>21:00</option>
                      <option value='21:30'>21:30</option>
                      <option value='22:00'>22:00</option>
                      <option value='22:30'>22:30</option>
                      <option value='23:00'>23:00</option>
                      <option value='23:30'>23:30</option>
                      <option value='24:00'>24:00</option>
                      <option value='24:30'>24:30</option>
                      <option value='25:00'>25:00</option>
                      <option value='25:30'>25:30</option>
                      <option value='26:00'>26:00</option>
                      <option value='26:30'>26:30</option>
                      <option value='27:00'>27:00</option>
                      <option value='27:30'>27:30</option>
                      <option value='28:00'>28:00</option>
                      <option value='28:30'>28:30</option>
                      <option value='29:00'>29:00</option>
                      <option value='29:30'>29:30</option>
                      <option value='30:00'>30:00</option>
                      <option value='30:30'>30:30</option>
                      <option value='31:00'>31:00</option>
                      <option value='31:30'>31:30</option>
                      <option value='32:00'>32:00</option>
                      <option value='32:30'>32:30</option>
                      <option value='33:00'>33:00</option>
                      <option value='33:30'>33:30</option>
                      <option value='34:00'>34:00</option>
                      <option value='34:30'>34:30</option>
                      <option value='35:00'>35:00</option>
                      <option value='35:30'>35:30</option>
                      <option value='36:00'>36:00</option>
                      <option value='36:30'>36:30</option>
                      <option value='37:00'>37:00</option>
                      <option value='37:30'>37:30</option>
                      <option value='38:00'>38:00</option>
                      <option value='38:30'>38:30</option>
                      <option value='39:00'>39:00</option>
                      <option value='39:30'>39:30</option>
                      <option value='40:00'>40:00</option>
                      <option value='40:30'>40:30</option>
                      <option value='41:00'>41:00</option>
                      <option value='41:30'>41:30</option>
                      <option value='42:00'>42:00</option>
                      <option value='42:30'>42:30</option>
                      <option value='43:00'>43:00</option>
                      <option value='43:30'>43:30</option>
                      <option value='44:00'>44:00</option>
                      <option value='44:30'>44:30</option>
                      <option value='45:00'>45:00</option>
                      <option value='45:30'>45:30</option>
                      <option value='46:00'>46:00</option>
                      <option value='46:30'>46:30</option>
                      <option value='47:00'>47:00</option>
                      <option value='47:30'>47:30</option>
                      <option value='48:00'>48:00</option>
                      <option value='48:30'>48:30</option>
                      <option value='49:00'>49:00</option>
                      <option value='49:30'>49:30</option>
                      <option value='50:00'>50:00</option>
                      <option value='50:30'>50:30</option>
                      <option value='51:00'>51:00</option>
                      <option value='51:30'>51:30</option>
                      <option value='52:00'>52:00</option>
                      <option value='52:30'>52:30</option>
                      <option value='53:00'>53:00</option>
                      <option value='53:30'>53:30</option>
                      <option value='54:00'>54:00</option>
                      <option value='54:30'>54:30</option>
                      <option value='55:00'>55:00</option>
                      <option value='55:30'>55:30</option>
                      <option value='56:00'>56:00</option>
                      <option value='56:30'>56:30</option>
                      <option value='57:00'>57:00</option>
                      <option value='57:30'>57:30</option>
                      <option value='58:00'>58:00</option>
                      <option value='58:30'>58:30</option>
                      <option value='59:00'>59:00</option>
                      <option value='59:30'>59:30</option>
                      <option value='60:00'>60:00</option>
                      <option value='60:30'>60:30</option>
                      <option value='61:00'>61:00</option>
                      <option value='61:30'>61:30</option>
                      <option value='62:00'>62:00</option>
                      <option value='62:30'>62:30</option>
                      <option value='63:00'>63:00</option>
                      <option value='63:30'>63:30</option>
                      <option value='64:00'>64:00</option>
                      <option value='64:30'>64:30</option>
                      <option value='65:00'>65:00</option>
                      <option value='65:30'>65:30</option>
                      <option value='66:00'>66:00</option>
                      <option value='66:30'>66:30</option>
                      <option value='67:00'>67:00</option>
                      <option value='67:30'>67:30</option>
                      <option value='68:00'>68:00</option>
                      <option value='68:30'>68:30</option>
                      <option value='69:00'>69:00</option>
                      <option value='69:30'>69:30</option>
                      <option value='70:00'>70:00</option>
                      <option value='70:30'>70:30</option>
                      <option value='71:00'>71:00</option>
                      <option value='71:30'>71:30</option>
                      <option value='72:00'>72:00</option>
                      <option value='72:30'>72:30</option>
                      <option value='73:00'>73:00</option>
                      <option value='73:30'>73:30</option>
                      <option value='74:00'>74:00</option>
                      <option value='74:30'>74:30</option>
                      <option value='75:00'>75:00</option>
                      <option value='75:30'>75:30</option>
                      <option value='76:00'>76:00</option>
                      <option value='76:30'>76:30</option>
                      <option value='77:00'>77:00</option>
                      <option value='77:30'>77:30</option>
                      <option value='78:00'>78:00</option>
                      <option value='78:30'>78:30</option>
                      <option value='79:00'>79:00</option>
                      <option value='79:30'>79:30</option>
                      <option value='80:00'>80:00</option>
                      <option value='80:30'>80:30</option>
                      <option value='81:00'>81:00</option>
                      <option value='81:30'>81:30</option>
                      <option value='82:00'>82:00</option>
                      <option value='82:30'>82:30</option>
                      <option value='83:00'>83:00</option>
                      <option value='83:30'>83:30</option>
                      <option value='84:00'>84:00</option>
                      <option value='84:30'>84:30</option>
                      <option value='85:00'>85:00</option>
                      <option value='85:30'>85:30</option>
                      <option value='86:00'>86:00</option>
                      <option value='86:30'>86:30</option>
                      <option value='87:00'>87:00</option>
                      <option value='87:30'>87:30</option>
                      <option value='88:00'>88:00</option>
                      <option value='88:30'>88:30</option>
                      <option value='89:00'>89:00</option>
                      <option value='89:30'>89:30</option>
                      <option value='90:00'>90:00</option>
                      <option value='90:30'>90:30</option>
                      <option value='91:00'>91:00</option>
                      <option value='91:30'>91:30</option>
                      <option value='92:00'>92:00</option>
                      <option value='92:30'>92:30</option>
                      <option value='93:00'>93:00</option>
                      <option value='93:30'>93:30</option>
                      <option value='94:00'>94:00</option>
                      <option value='94:30'>94:30</option>
                      <option value='95:00'>95:00</option>
                      <option value='95:30'>95:30</option>
                      <option value='96:00'>96:00</option>
                      <option value='96:30'>96:30</option>
                      <option value='97:00'>97:00</option>
                      <option value='97:30'>97:30</option>
                      <option value='98:00'>98:00</option>
                      <option value='98:30'>98:30</option>
                      <option value='99:00'>99:00</option>
                      <option value='99:30'>99:30</option>
                      <option value='100:00'>100:00</option>
                      <option value='100:30'>100:30</option>
                      <option value='101:00'>101:00</option>
                      <option value='101:30'>101:30</option>
                      <option value='102:00'>102:00</option>
                      <option value='102:30'>102:30</option>
                      <option value='103:00'>103:00</option>
                      <option value='103:30'>103:30</option>
                      <option value='104:00'>104:00</option>
                      <option value='104:30'>104:30</option>
                      <option value='105:00'>105:00</option>
                      <option value='105:30'>105:30</option>
                      <option value='106:00'>106:00</option>
                      <option value='106:30'>106:30</option>
                      <option value='107:00'>107:00</option>
                      <option value='107:30'>107:30</option>
                      <option value='108:00'>108:00</option>
                      <option value='108:30'>108:30</option>
                      <option value='109:00'>109:00</option>
                      <option value='109:30'>109:30</option>
                      <option value='110:00'>110:00</option>
                      <option value='110:30'>110:30</option>
                      <option value='111:00'>111:00</option>
                      <option value='111:30'>111:30</option>
                      <option value='112:00'>112:00</option>
                      <option value='112:30'>112:30</option>
                      <option value='113:00'>113:00</option>
                      <option value='113:30'>113:30</option>
                      <option value='114:00'>114:00</option>
                      <option value='114:30'>114:30</option>
                      <option value='115:00'>115:00</option>
                      <option value='115:30'>115:30</option>
                      <option value='116:00'>116:00</option>
                      <option value='116:30'>116:30</option>
                      <option value='117:00'>117:00</option>
                      <option value='117:30'>117:30</option>
                      <option value='118:00'>118:00</option>
                      <option value='118:30'>118:30</option>
                      <option value='119:00'>119:00</option>
                      <option value='119:30'>119:30</option>
                      <option value='120:00'>120:00</option>
                      <option value='120:30'>120:30</option>
                      <option value='121:00'>121:00</option>
                      <option value='121:30'>121:30</option>
                      <option value='122:00'>122:00</option>
                      <option value='122:30'>122:30</option>
                      <option value='123:00'>123:00</option>
                      <option value='123:30'>123:30</option>
                      <option value='124:00'>124:00</option>
                      <option value='124:30'>124:30</option>
                      <option value='125:00'>125:00</option>
                      <option value='125:30'>125:30</option>
                      <option value='126:00'>126:00</option>
                      <option value='126:30'>126:30</option>
                      <option value='127:00'>127:00</option>
                      <option value='127:30'>127:30</option>
                      <option value='128:00'>128:00</option>
                      <option value='128:30'>128:30</option>
                      <option value='129:00'>129:00</option>
                      <option value='129:30'>129:30</option>
                      <option value='130:00'>130:00</option>
                      <option value='130:30'>130:30</option>
                      <option value='131:00'>131:00</option>
                      <option value='131:30'>131:30</option>
                      <option value='132:00'>132:00</option>
                      <option value='132:30'>132:30</option>
                      <option value='133:00'>133:00</option>
                      <option value='133:30'>133:30</option>
                      <option value='134:00'>134:00</option>
                      <option value='134:30'>134:30</option>
                      <option value='135:00'>135:00</option>
                      <option value='135:30'>135:30</option>
                      <option value='136:00'>136:00</option>
                      <option value='136:30'>136:30</option>
                      <option value='137:00'>137:00</option>
                      <option value='137:30'>137:30</option>
                      <option value='138:00'>138:00</option>
                      <option value='138:30'>138:30</option>
                      <option value='139:00'>139:00</option>
                      <option value='139:30'>139:30</option>
                      <option value='140:00'>140:00</option>
                      <option value='140:30'>140:30</option>
                      <option value='141:00'>141:00</option>
                      <option value='141:30'>141:30</option>
                      <option value='142:00'>142:00</option>
                      <option value='142:30'>142:30</option>
                      <option value='143:00'>143:00</option>
                      <option value='143:30'>143:30</option>
                      <option value='144:00'>144:00</option>
                      <option value='144:30'>144:30</option>
                      <option value='145:00'>145:00</option>
                      <option value='145:30'>145:30</option>
                      <option value='146:00'>146:00</option>
                      <option value='146:30'>146:30</option>
                      <option value='147:00'>147:00</option>
                      <option value='147:30'>147:30</option>
                      <option value='148:00'>148:00</option>
                      <option value='148:30'>148:30</option>
                      <option value='149:00'>149:00</option>
                      <option value='149:30'>149:30</option>
                      <option value='150:00'>150:00</option>
                    </Form.Select>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label='Red*'
                      className='mb-3'
                      name='Red*'
                      style={{ backgroundColor: '#dc3545', color: '#000000' }}
                      value={red}
                      onChange={e => setRed(e.target.value)}
                    >
                      <option value=''>Red *</option>
                      <option value='0:00'>0:00</option>
                      <option value='0:30'>0:30</option>
                      <option value='1:00'>1:00</option>
                      <option value='1:30'>1:30</option>
                      <option value='2:00'>2:00</option>
                      <option value='2:30'>2:30</option>
                      <option value='3:00'>3:00</option>
                      <option value='3:30'>3:30</option>
                      <option value='4:00'>4:00</option>
                      <option value='4:30'>4:30</option>
                      <option value='5:00'>5:00</option>
                      <option value='5:30'>5:30</option>
                      <option value='6:00'>6:00</option>
                      <option value='6:30'>6:30</option>
                      <option value='7:00'>7:00</option>
                      <option value='7:30'>7:30</option>
                      <option value='8:00'>8:00</option>
                      <option value='8:30'>8:30</option>
                      <option value='9:00'>9:00</option>
                      <option value='9:30'>9:30</option>
                      <option value='10:00'>10:00</option>
                      <option value='10:30'>10:30</option>
                      <option value='11:00'>11:00</option>
                      <option value='11:30'>11:30</option>
                      <option value='12:00'>12:00</option>
                      <option value='12:30'>12:30</option>
                      <option value='13:00'>13:00</option>
                      <option value='13:30'>13:30</option>
                      <option value='14:00'>14:00</option>
                      <option value='14:30'>14:30</option>
                      <option value='15:00'>15:00</option>
                      <option value='15:30'>15:30</option>
                      <option value='16:00'>16:00</option>
                      <option value='16:30'>16:30</option>
                      <option value='17:00'>17:00</option>
                      <option value='17:30'>17:30</option>
                      <option value='18:00'>18:00</option>
                      <option value='18:30'>18:30</option>
                      <option value='19:00'>19:00</option>
                      <option value='19:30'>19:30</option>
                      <option value='20:00'>20:00</option>
                      <option value='20:30'>20:30</option>
                      <option value='21:00'>21:00</option>
                      <option value='21:30'>21:30</option>
                      <option value='22:00'>22:00</option>
                      <option value='22:30'>22:30</option>
                      <option value='23:00'>23:00</option>
                      <option value='23:30'>23:30</option>
                      <option value='24:00'>24:00</option>
                      <option value='24:30'>24:30</option>
                      <option value='25:00'>25:00</option>
                      <option value='25:30'>25:30</option>
                      <option value='26:00'>26:00</option>
                      <option value='26:30'>26:30</option>
                      <option value='27:00'>27:00</option>
                      <option value='27:30'>27:30</option>
                      <option value='28:00'>28:00</option>
                      <option value='28:30'>28:30</option>
                      <option value='29:00'>29:00</option>
                      <option value='29:30'>29:30</option>
                      <option value='30:00'>30:00</option>
                      <option value='30:30'>30:30</option>
                      <option value='31:00'>31:00</option>
                      <option value='31:30'>31:30</option>
                      <option value='32:00'>32:00</option>
                      <option value='32:30'>32:30</option>
                      <option value='33:00'>33:00</option>
                      <option value='33:30'>33:30</option>
                      <option value='34:00'>34:00</option>
                      <option value='34:30'>34:30</option>
                      <option value='35:00'>35:00</option>
                      <option value='35:30'>35:30</option>
                      <option value='36:00'>36:00</option>
                      <option value='36:30'>36:30</option>
                      <option value='37:00'>37:00</option>
                      <option value='37:30'>37:30</option>
                      <option value='38:00'>38:00</option>
                      <option value='38:30'>38:30</option>
                      <option value='39:00'>39:00</option>
                      <option value='39:30'>39:30</option>
                      <option value='40:00'>40:00</option>
                      <option value='40:30'>40:30</option>
                      <option value='41:00'>41:00</option>
                      <option value='41:30'>41:30</option>
                      <option value='42:00'>42:00</option>
                      <option value='42:30'>42:30</option>
                      <option value='43:00'>43:00</option>
                      <option value='43:30'>43:30</option>
                      <option value='44:00'>44:00</option>
                      <option value='44:30'>44:30</option>
                      <option value='45:00'>45:00</option>
                      <option value='45:30'>45:30</option>
                      <option value='46:00'>46:00</option>
                      <option value='46:30'>46:30</option>
                      <option value='47:00'>47:00</option>
                      <option value='47:30'>47:30</option>
                      <option value='48:00'>48:00</option>
                      <option value='48:30'>48:30</option>
                      <option value='49:00'>49:00</option>
                      <option value='49:30'>49:30</option>
                      <option value='50:00'>50:00</option>
                      <option value='50:30'>50:30</option>
                      <option value='51:00'>51:00</option>
                      <option value='51:30'>51:30</option>
                      <option value='52:00'>52:00</option>
                      <option value='52:30'>52:30</option>
                      <option value='53:00'>53:00</option>
                      <option value='53:30'>53:30</option>
                      <option value='54:00'>54:00</option>
                      <option value='54:30'>54:30</option>
                      <option value='55:00'>55:00</option>
                      <option value='55:30'>55:30</option>
                      <option value='56:00'>56:00</option>
                      <option value='56:30'>56:30</option>
                      <option value='57:00'>57:00</option>
                      <option value='57:30'>57:30</option>
                      <option value='58:00'>58:00</option>
                      <option value='58:30'>58:30</option>
                      <option value='59:00'>59:00</option>
                      <option value='59:30'>59:30</option>
                      <option value='60:00'>60:00</option>
                      <option value='60:30'>60:30</option>
                      <option value='61:00'>61:00</option>
                      <option value='61:30'>61:30</option>
                      <option value='62:00'>62:00</option>
                      <option value='62:30'>62:30</option>
                      <option value='63:00'>63:00</option>
                      <option value='63:30'>63:30</option>
                      <option value='64:00'>64:00</option>
                      <option value='64:30'>64:30</option>
                      <option value='65:00'>65:00</option>
                      <option value='65:30'>65:30</option>
                      <option value='66:00'>66:00</option>
                      <option value='66:30'>66:30</option>
                      <option value='67:00'>67:00</option>
                      <option value='67:30'>67:30</option>
                      <option value='68:00'>68:00</option>
                      <option value='68:30'>68:30</option>
                      <option value='69:00'>69:00</option>
                      <option value='69:30'>69:30</option>
                      <option value='70:00'>70:00</option>
                      <option value='70:30'>70:30</option>
                      <option value='71:00'>71:00</option>
                      <option value='71:30'>71:30</option>
                      <option value='72:00'>72:00</option>
                      <option value='72:30'>72:30</option>
                      <option value='73:00'>73:00</option>
                      <option value='73:30'>73:30</option>
                      <option value='74:00'>74:00</option>
                      <option value='74:30'>74:30</option>
                      <option value='75:00'>75:00</option>
                      <option value='75:30'>75:30</option>
                      <option value='76:00'>76:00</option>
                      <option value='76:30'>76:30</option>
                      <option value='77:00'>77:00</option>
                      <option value='77:30'>77:30</option>
                      <option value='78:00'>78:00</option>
                      <option value='78:30'>78:30</option>
                      <option value='79:00'>79:00</option>
                      <option value='79:30'>79:30</option>
                      <option value='80:00'>80:00</option>
                      <option value='80:30'>80:30</option>
                      <option value='81:00'>81:00</option>
                      <option value='81:30'>81:30</option>
                      <option value='82:00'>82:00</option>
                      <option value='82:30'>82:30</option>
                      <option value='83:00'>83:00</option>
                      <option value='83:30'>83:30</option>
                      <option value='84:00'>84:00</option>
                      <option value='84:30'>84:30</option>
                      <option value='85:00'>85:00</option>
                      <option value='85:30'>85:30</option>
                      <option value='86:00'>86:00</option>
                      <option value='86:30'>86:30</option>
                      <option value='87:00'>87:00</option>
                      <option value='87:30'>87:30</option>
                      <option value='88:00'>88:00</option>
                      <option value='88:30'>88:30</option>
                      <option value='89:00'>89:00</option>
                      <option value='89:30'>89:30</option>
                      <option value='90:00'>90:00</option>
                      <option value='90:30'>90:30</option>
                      <option value='91:00'>91:00</option>
                      <option value='91:30'>91:30</option>
                      <option value='92:00'>92:00</option>
                      <option value='92:30'>92:30</option>
                      <option value='93:00'>93:00</option>
                      <option value='93:30'>93:30</option>
                      <option value='94:00'>94:00</option>
                      <option value='94:30'>94:30</option>
                      <option value='95:00'>95:00</option>
                      <option value='95:30'>95:30</option>
                      <option value='96:00'>96:00</option>
                      <option value='96:30'>96:30</option>
                      <option value='97:00'>97:00</option>
                      <option value='97:30'>97:30</option>
                      <option value='98:00'>98:00</option>
                      <option value='98:30'>98:30</option>
                      <option value='99:00'>99:00</option>
                      <option value='99:30'>99:30</option>
                      <option value='100:00'>100:00</option>
                      <option value='100:30'>100:30</option>
                      <option value='101:00'>101:00</option>
                      <option value='101:30'>101:30</option>
                      <option value='102:00'>102:00</option>
                      <option value='102:30'>102:30</option>
                      <option value='103:00'>103:00</option>
                      <option value='103:30'>103:30</option>
                      <option value='104:00'>104:00</option>
                      <option value='104:30'>104:30</option>
                      <option value='105:00'>105:00</option>
                      <option value='105:30'>105:30</option>
                      <option value='106:00'>106:00</option>
                      <option value='106:30'>106:30</option>
                      <option value='107:00'>107:00</option>
                      <option value='107:30'>107:30</option>
                      <option value='108:00'>108:00</option>
                      <option value='108:30'>108:30</option>
                      <option value='109:00'>109:00</option>
                      <option value='109:30'>109:30</option>
                      <option value='110:00'>110:00</option>
                      <option value='110:30'>110:30</option>
                      <option value='111:00'>111:00</option>
                      <option value='111:30'>111:30</option>
                      <option value='112:00'>112:00</option>
                      <option value='112:30'>112:30</option>
                      <option value='113:00'>113:00</option>
                      <option value='113:30'>113:30</option>
                      <option value='114:00'>114:00</option>
                      <option value='114:30'>114:30</option>
                      <option value='115:00'>115:00</option>
                      <option value='115:30'>115:30</option>
                      <option value='116:00'>116:00</option>
                      <option value='116:30'>116:30</option>
                      <option value='117:00'>117:00</option>
                      <option value='117:30'>117:30</option>
                      <option value='118:00'>118:00</option>
                      <option value='118:30'>118:30</option>
                      <option value='119:00'>119:00</option>
                      <option value='119:30'>119:30</option>
                      <option value='120:00'>120:00</option>
                      <option value='120:30'>120:30</option>
                      <option value='121:00'>121:00</option>
                      <option value='121:30'>121:30</option>
                      <option value='122:00'>122:00</option>
                      <option value='122:30'>122:30</option>
                      <option value='123:00'>123:00</option>
                      <option value='123:30'>123:30</option>
                      <option value='124:00'>124:00</option>
                      <option value='124:30'>124:30</option>
                      <option value='125:00'>125:00</option>
                      <option value='125:30'>125:30</option>
                      <option value='126:00'>126:00</option>
                      <option value='126:30'>126:30</option>
                      <option value='127:00'>127:00</option>
                      <option value='127:30'>127:30</option>
                      <option value='128:00'>128:00</option>
                      <option value='128:30'>128:30</option>
                      <option value='129:00'>129:00</option>
                      <option value='129:30'>129:30</option>
                      <option value='130:00'>130:00</option>
                      <option value='130:30'>130:30</option>
                      <option value='131:00'>131:00</option>
                      <option value='131:30'>131:30</option>
                      <option value='132:00'>132:00</option>
                      <option value='132:30'>132:30</option>
                      <option value='133:00'>133:00</option>
                      <option value='133:30'>133:30</option>
                      <option value='134:00'>134:00</option>
                      <option value='134:30'>134:30</option>
                      <option value='135:00'>135:00</option>
                      <option value='135:30'>135:30</option>
                      <option value='136:00'>136:00</option>
                      <option value='136:30'>136:30</option>
                      <option value='137:00'>137:00</option>
                      <option value='137:30'>137:30</option>
                      <option value='138:00'>138:00</option>
                      <option value='138:30'>138:30</option>
                      <option value='139:00'>139:00</option>
                      <option value='139:30'>139:30</option>
                      <option value='140:00'>140:00</option>
                      <option value='140:30'>140:30</option>
                      <option value='141:00'>141:00</option>
                      <option value='141:30'>141:30</option>
                      <option value='142:00'>142:00</option>
                      <option value='142:30'>142:30</option>
                      <option value='143:00'>143:00</option>
                      <option value='143:30'>143:30</option>
                      <option value='144:00'>144:00</option>
                      <option value='144:30'>144:30</option>
                      <option value='145:00'>145:00</option>
                      <option value='145:30'>145:30</option>
                      <option value='146:00'>146:00</option>
                      <option value='146:30'>146:30</option>
                      <option value='147:00'>147:00</option>
                      <option value='147:30'>147:30</option>
                      <option value='148:00'>148:00</option>
                      <option value='148:30'>148:30</option>
                      <option value='149:00'>149:00</option>
                      <option value='149:30'>149:30</option>
                      <option value='150:00'>150:00</option>
                    </Form.Select>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label='Total *'
                      className='mb-3'
                      name='Total *'
                      style={{ backgroundColor: '#3498db', color: '#000000' }}
                      value={total}
                      onChange={e => setTotal(e.target.value)}
                    >
                      <option value=''>Max *</option>
                      <option value='0:00'>0:00</option>
                      <option value='0:30'>0:30</option>
                      <option value='1:00'>1:00</option>
                      <option value='1:30'>1:30</option>
                      <option value='2:00'>2:00</option>
                      <option value='2:30'>2:30</option>
                      <option value='3:00'>3:00</option>
                      <option value='3:30'>3:30</option>
                      <option value='4:00'>4:00</option>
                      <option value='4:30'>4:30</option>
                      <option value='5:00'>5:00</option>
                      <option value='5:30'>5:30</option>
                      <option value='6:00'>6:00</option>
                      <option value='6:30'>6:30</option>
                      <option value='7:00'>7:00</option>
                      <option value='7:30'>7:30</option>
                      <option value='8:00'>8:00</option>
                      <option value='8:30'>8:30</option>
                      <option value='9:00'>9:00</option>
                      <option value='9:30'>9:30</option>
                      <option value='10:00'>10:00</option>
                      <option value='10:30'>10:30</option>
                      <option value='11:00'>11:00</option>
                      <option value='11:30'>11:30</option>
                      <option value='12:00'>12:00</option>
                      <option value='12:30'>12:30</option>
                      <option value='13:00'>13:00</option>
                      <option value='13:30'>13:30</option>
                      <option value='14:00'>14:00</option>
                      <option value='14:30'>14:30</option>
                      <option value='15:00'>15:00</option>
                      <option value='15:30'>15:30</option>
                      <option value='16:00'>16:00</option>
                      <option value='16:30'>16:30</option>
                      <option value='17:00'>17:00</option>
                      <option value='17:30'>17:30</option>
                      <option value='18:00'>18:00</option>
                      <option value='18:30'>18:30</option>
                      <option value='19:00'>19:00</option>
                      <option value='19:30'>19:30</option>
                      <option value='20:00'>20:00</option>
                      <option value='20:30'>20:30</option>
                      <option value='21:00'>21:00</option>
                      <option value='21:30'>21:30</option>
                      <option value='22:00'>22:00</option>
                      <option value='22:30'>22:30</option>
                      <option value='23:00'>23:00</option>
                      <option value='23:30'>23:30</option>
                      <option value='24:00'>24:00</option>
                      <option value='24:30'>24:30</option>
                      <option value='25:00'>25:00</option>
                      <option value='25:30'>25:30</option>
                      <option value='26:00'>26:00</option>
                      <option value='26:30'>26:30</option>
                      <option value='27:00'>27:00</option>
                      <option value='27:30'>27:30</option>
                      <option value='28:00'>28:00</option>
                      <option value='28:30'>28:30</option>
                      <option value='29:00'>29:00</option>
                      <option value='29:30'>29:30</option>
                      <option value='30:00'>30:00</option>
                      <option value='30:30'>30:30</option>
                      <option value='31:00'>31:00</option>
                      <option value='31:30'>31:30</option>
                      <option value='32:00'>32:00</option>
                      <option value='32:30'>32:30</option>
                      <option value='33:00'>33:00</option>
                      <option value='33:30'>33:30</option>
                      <option value='34:00'>34:00</option>
                      <option value='34:30'>34:30</option>
                      <option value='35:00'>35:00</option>
                      <option value='35:30'>35:30</option>
                      <option value='36:00'>36:00</option>
                      <option value='36:30'>36:30</option>
                      <option value='37:00'>37:00</option>
                      <option value='37:30'>37:30</option>
                      <option value='38:00'>38:00</option>
                      <option value='38:30'>38:30</option>
                      <option value='39:00'>39:00</option>
                      <option value='39:30'>39:30</option>
                      <option value='40:00'>40:00</option>
                      <option value='40:30'>40:30</option>
                      <option value='41:00'>41:00</option>
                      <option value='41:30'>41:30</option>
                      <option value='42:00'>42:00</option>
                      <option value='42:30'>42:30</option>
                      <option value='43:00'>43:00</option>
                      <option value='43:30'>43:30</option>
                      <option value='44:00'>44:00</option>
                      <option value='44:30'>44:30</option>
                      <option value='45:00'>45:00</option>
                      <option value='45:30'>45:30</option>
                      <option value='46:00'>46:00</option>
                      <option value='46:30'>46:30</option>
                      <option value='47:00'>47:00</option>
                      <option value='47:30'>47:30</option>
                      <option value='48:00'>48:00</option>
                      <option value='48:30'>48:30</option>
                      <option value='49:00'>49:00</option>
                      <option value='49:30'>49:30</option>
                      <option value='50:00'>50:00</option>
                      <option value='50:30'>50:30</option>
                      <option value='51:00'>51:00</option>
                      <option value='51:30'>51:30</option>
                      <option value='52:00'>52:00</option>
                      <option value='52:30'>52:30</option>
                      <option value='53:00'>53:00</option>
                      <option value='53:30'>53:30</option>
                      <option value='54:00'>54:00</option>
                      <option value='54:30'>54:30</option>
                      <option value='55:00'>55:00</option>
                      <option value='55:30'>55:30</option>
                      <option value='56:00'>56:00</option>
                      <option value='56:30'>56:30</option>
                      <option value='57:00'>57:00</option>
                      <option value='57:30'>57:30</option>
                      <option value='58:00'>58:00</option>
                      <option value='58:30'>58:30</option>
                      <option value='59:00'>59:00</option>
                      <option value='59:30'>59:30</option>
                      <option value='60:00'>60:00</option>
                      <option value='60:30'>60:30</option>
                      <option value='61:00'>61:00</option>
                      <option value='61:30'>61:30</option>
                      <option value='62:00'>62:00</option>
                      <option value='62:30'>62:30</option>
                      <option value='63:00'>63:00</option>
                      <option value='63:30'>63:30</option>
                      <option value='64:00'>64:00</option>
                      <option value='64:30'>64:30</option>
                      <option value='65:00'>65:00</option>
                      <option value='65:30'>65:30</option>
                      <option value='66:00'>66:00</option>
                      <option value='66:30'>66:30</option>
                      <option value='67:00'>67:00</option>
                      <option value='67:30'>67:30</option>
                      <option value='68:00'>68:00</option>
                      <option value='68:30'>68:30</option>
                      <option value='69:00'>69:00</option>
                      <option value='69:30'>69:30</option>
                      <option value='70:00'>70:00</option>
                      <option value='70:30'>70:30</option>
                      <option value='71:00'>71:00</option>
                      <option value='71:30'>71:30</option>
                      <option value='72:00'>72:00</option>
                      <option value='72:30'>72:30</option>
                      <option value='73:00'>73:00</option>
                      <option value='73:30'>73:30</option>
                      <option value='74:00'>74:00</option>
                      <option value='74:30'>74:30</option>
                      <option value='75:00'>75:00</option>
                      <option value='75:30'>75:30</option>
                      <option value='76:00'>76:00</option>
                      <option value='76:30'>76:30</option>
                      <option value='77:00'>77:00</option>
                      <option value='77:30'>77:30</option>
                      <option value='78:00'>78:00</option>
                      <option value='78:30'>78:30</option>
                      <option value='79:00'>79:00</option>
                      <option value='79:30'>79:30</option>
                      <option value='80:00'>80:00</option>
                      <option value='80:30'>80:30</option>
                      <option value='81:00'>81:00</option>
                      <option value='81:30'>81:30</option>
                      <option value='82:00'>82:00</option>
                      <option value='82:30'>82:30</option>
                      <option value='83:00'>83:00</option>
                      <option value='83:30'>83:30</option>
                      <option value='84:00'>84:00</option>
                      <option value='84:30'>84:30</option>
                      <option value='85:00'>85:00</option>
                      <option value='85:30'>85:30</option>
                      <option value='86:00'>86:00</option>
                      <option value='86:30'>86:30</option>
                      <option value='87:00'>87:00</option>
                      <option value='87:30'>87:30</option>
                      <option value='88:00'>88:00</option>
                      <option value='88:30'>88:30</option>
                      <option value='89:00'>89:00</option>
                      <option value='89:30'>89:30</option>
                      <option value='90:00'>90:00</option>
                      <option value='90:30'>90:30</option>
                      <option value='91:00'>91:00</option>
                      <option value='91:30'>91:30</option>
                      <option value='92:00'>92:00</option>
                      <option value='92:30'>92:30</option>
                      <option value='93:00'>93:00</option>
                      <option value='93:30'>93:30</option>
                      <option value='94:00'>94:00</option>
                      <option value='94:30'>94:30</option>
                      <option value='95:00'>95:00</option>
                      <option value='95:30'>95:30</option>
                      <option value='96:00'>96:00</option>
                      <option value='96:30'>96:30</option>
                      <option value='97:00'>97:00</option>
                      <option value='97:30'>97:30</option>
                      <option value='98:00'>98:00</option>
                      <option value='98:30'>98:30</option>
                      <option value='99:00'>99:00</option>
                      <option value='99:30'>99:30</option>
                      <option value='100:00'>100:00</option>
                      <option value='100:30'>100:30</option>
                      <option value='101:00'>101:00</option>
                      <option value='101:30'>101:30</option>
                      <option value='102:00'>102:00</option>
                      <option value='102:30'>102:30</option>
                      <option value='103:00'>103:00</option>
                      <option value='103:30'>103:30</option>
                      <option value='104:00'>104:00</option>
                      <option value='104:30'>104:30</option>
                      <option value='105:00'>105:00</option>
                      <option value='105:30'>105:30</option>
                      <option value='106:00'>106:00</option>
                      <option value='106:30'>106:30</option>
                      <option value='107:00'>107:00</option>
                      <option value='107:30'>107:30</option>
                      <option value='108:00'>108:00</option>
                      <option value='108:30'>108:30</option>
                      <option value='109:00'>109:00</option>
                      <option value='109:30'>109:30</option>
                      <option value='110:00'>110:00</option>
                      <option value='110:30'>110:30</option>
                      <option value='111:00'>111:00</option>
                      <option value='111:30'>111:30</option>
                      <option value='112:00'>112:00</option>
                      <option value='112:30'>112:30</option>
                      <option value='113:00'>113:00</option>
                      <option value='113:30'>113:30</option>
                      <option value='114:00'>114:00</option>
                      <option value='114:30'>114:30</option>
                      <option value='115:00'>115:00</option>
                      <option value='115:30'>115:30</option>
                      <option value='116:00'>116:00</option>
                      <option value='116:30'>116:30</option>
                      <option value='117:00'>117:00</option>
                      <option value='117:30'>117:30</option>
                      <option value='118:00'>118:00</option>
                      <option value='118:30'>118:30</option>
                      <option value='119:00'>119:00</option>
                      <option value='119:30'>119:30</option>
                      <option value='120:00'>120:00</option>
                      <option value='120:30'>120:30</option>
                      <option value='121:00'>121:00</option>
                      <option value='121:30'>121:30</option>
                      <option value='122:00'>122:00</option>
                      <option value='122:30'>122:30</option>
                      <option value='123:00'>123:00</option>
                      <option value='123:30'>123:30</option>
                      <option value='124:00'>124:00</option>
                      <option value='124:30'>124:30</option>
                      <option value='125:00'>125:00</option>
                      <option value='125:30'>125:30</option>
                      <option value='126:00'>126:00</option>
                      <option value='126:30'>126:30</option>
                      <option value='127:00'>127:00</option>
                      <option value='127:30'>127:30</option>
                      <option value='128:00'>128:00</option>
                      <option value='128:30'>128:30</option>
                      <option value='129:00'>129:00</option>
                      <option value='129:30'>129:30</option>
                      <option value='130:00'>130:00</option>
                      <option value='130:30'>130:30</option>
                      <option value='131:00'>131:00</option>
                      <option value='131:30'>131:30</option>
                      <option value='132:00'>132:00</option>
                      <option value='132:30'>132:30</option>
                      <option value='133:00'>133:00</option>
                      <option value='133:30'>133:30</option>
                      <option value='134:00'>134:00</option>
                      <option value='134:30'>134:30</option>
                      <option value='135:00'>135:00</option>
                      <option value='135:30'>135:30</option>
                      <option value='136:00'>136:00</option>
                      <option value='136:30'>136:30</option>
                      <option value='137:00'>137:00</option>
                      <option value='137:30'>137:30</option>
                      <option value='138:00'>138:00</option>
                      <option value='138:30'>138:30</option>
                      <option value='139:00'>139:00</option>
                      <option value='139:30'>139:30</option>
                      <option value='140:00'>140:00</option>
                      <option value='140:30'>140:30</option>
                      <option value='141:00'>141:00</option>
                      <option value='141:30'>141:30</option>
                      <option value='142:00'>142:00</option>
                      <option value='142:30'>142:30</option>
                      <option value='143:00'>143:00</option>
                      <option value='143:30'>143:30</option>
                      <option value='144:00'>144:00</option>
                      <option value='144:30'>144:30</option>
                      <option value='145:00'>145:00</option>
                      <option value='145:30'>145:30</option>
                      <option value='146:00'>146:00</option>
                      <option value='146:30'>146:30</option>
                      <option value='147:00'>147:00</option>
                      <option value='147:30'>147:30</option>
                      <option value='148:00'>148:00</option>
                      <option value='148:30'>148:30</option>
                      <option value='149:00'>149:00</option>
                      <option value='149:30'>149:30</option>
                      <option value='150:00'>150:00</option>
                    </Form.Select>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>
                      If green is selected, you must select amber too.
                    </p>
                    <p>
                      * mandatory field
                    </p>
                  </Col>
                </Row>
              </Form.Group>
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between events-admin-form-footer'>
              {saveLoading
                ?
                <>
                  <AppLoader />
                  Adding Event ...
                </>
                :
                <>
                  <Button variant="success" type='submit' onClick={handleSubmit} className='me-2 events-admin-primary-btn'>
                    Add Event
                  </Button>
                  <Button variant="danger" onClick={handleCloseCard} className='events-admin-danger-btn'>
                    Cancel
                  </Button>
                </>
              }
            </Card.Footer>
          </Form>
        </Card>
      )}
    </>
  )

}
